export const endPoints = {
  CLIENT_SEND_MESSAGE: '/v1/client/send-message'
};
